import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardOrganizationSummaryFormatDocument,
  type DashboardOrganizationSummaryFormatQuery,
  type DashboardOrganizationSummaryFormatQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_ORGANIZATION_SUMMARY_FORMAT_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const id = requireParam(props.params, "id");

  const { data } = await client.query<
    DashboardOrganizationSummaryFormatQuery,
    DashboardOrganizationSummaryFormatQueryVariables
  >({
    query: DashboardOrganizationSummaryFormatDocument,
    variables: { id },
    fetchPolicy: "network-only",
  });

  return data;
};
